import { render } from "./WebcamPlayer.vue?vue&type=template&id=2d0f9917&scoped=true"
import script from "./WebcamPlayer.vue?vue&type=script&lang=js"
export * from "./WebcamPlayer.vue?vue&type=script&lang=js"

import "./WebcamPlayer.vue?vue&type=style&index=0&id=2d0f9917&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0f9917"],['__file',"src/components/ui/WebcamPlayer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d0f9917"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d0f9917', __exports__)) {
    api.reload('2d0f9917', __exports__)
  }
  
  module.hot.accept("./WebcamPlayer.vue?vue&type=template&id=2d0f9917&scoped=true", () => {
    api.rerender('2d0f9917', render)
  })

}


export default __exports__